import Api from "../constants/api";
import Url from "../constants/urls";
import dispatcher from "../dispatchers/dispatcher";

module.exports = {
    _generateS3Url: function(param, rType) {
        dispatcher.dispatch({ type: "LOADER", loader: true });

        Api._callAPI(
            Url.ATTACHMENTS_S3,
            "POST",
            param,
            (type, dt) => {
                if (type === "success") {
                    if (dt.res_code === "0") {
                        dispatcher.dispatch({
                            type: "S3_URL_GENERATED",
                            response: dt.res_data
                        });
                    } else {
                        dispatcher.dispatch({
                            type: "SNACKBAR",
                            str: dt.res_str
                        });
                    }
                } else {
                    dispatcher.dispatch({
                        type: "SNACKBAR",
                        str: Api._showErrorMsg(dt.status, dt.responseJSON || "")
                    });
                }
                dispatcher.dispatch({
                    type: "LOADER",
                    loader: false
                });
            },
            rType
        );
    },

    _generateOneTimeOtp: function(query) {
        dispatcher.dispatch({
            type: "LOADER",
            loader: true
        });
        Api._callAPI(`${Url.GET_OTP}?otp_type=one-time-password`, "get", query, (type, dt) => {
            if (type == "success") {
                console.log(dt?.res_str)
            } else {
                dispatcher.dispatch({
                    type: "SNACKBAR",
                    str: Api._showErrorMsg(dt.status, dt.responseJSON || "")
                });
            }
            dispatcher.dispatch({
                type: "LOADER",
                loader: false
            });
        });
    }
};
